// import _ from "lodash";
import { couponList } from '@/util/plan'
import { Toast } from 'vant'
export const showToast = (msg, defaultMsg = '操作失败', option = {}) => {
  if (typeof defaultMsg === 'object') {
    option = defaultMsg
    defaultMsg = option.defaultMsg || '操作失败'
  }
  Toast({ message: msg || defaultMsg, position: 'bottom', ...option })
}
// 优惠券按钮基础配置
export const couponBtn = (name, option = {}) => {
  let options = Object.assign({ size: 'couponSize' }, option)
  const getBtn = { text: '免费领取', type: 'active', ...options }
  const useBtn = { text: '去使用', type: 'unabled', ...options }
  const hasBtn = { text: '已领取', type: 'unabled', ...options }
  const nullBtn = { text: '已领光', type: 'disabled', ...options }
  const res = { getBtn, useBtn, hasBtn, nullBtn }
  return name && res[name] ? res[name] : res
}
// 设置按钮
export const setCouponBtn = item => {
  let btn = couponBtn('getBtn')
  let statisInfo = item.statisInfo || {}

  // 按经销商发放的券：
  if (item.distributeTypeFlag === 1) {
    /*
      进行中&有发放&任一经销商仍有余量的优惠券，展示“去领取”
      未生效、已暂停和已结束的优惠券，不显示
      无经销商发放的优惠券，不显示
      进行中&已发放，所有经销商已发放=已领取，显示“已领光”
    */
    // totalResidueCount  经销商的总剩余领取数量
    if (statisInfo.totalResidueCount > 0) {
      btn = couponBtn('getBtn')
    } else {
      btn = couponBtn('nullBtn')
    }
  }
  // 厂家发放的券
  if (item.distributeTypeFlag === 2) {
    /*
      生效中&有发放&仍有剩余领取数量的优惠券，展示“去领取”
      未生效、已暂停和已结束的优惠券，不显示
      无发放的优惠券，不显示
      进行中&已发放，已发放=已领取，显示“已领光”
      若当前微信号已达领取上限N，显示“已经领取N/N”
      distributedCount--发放数量    purchasedCount--领取数量    totalResidueCount--剩余可发放数量
      currentCustomerReceiveCount--当前用户已领取数量
    */
    if (statisInfo.totalResidueCount > 0) {
      btn = couponBtn('getBtn')
    }
    if (statisInfo.distributedCount === statisInfo.purchasedCount) {
      btn = couponBtn('nullBtn')
    }
    // 已领取 = 限制的数量
    if (statisInfo.currentCustomerReceiveCount === item.purchaseLimitPerCustomer) {
      let text = `已领取${item.purchaseLimitPerCustomer}/${item.purchaseLimitPerCustomer}`
      btn = couponBtn('hasBtn', { text })
    }
  }
  return btn
}
// 组合列表数据
export const reorganizeListData = data => {
  // console.log("reorganizeListData-->", data);
  let list = couponList(data)
  return list.map(item => {
    const btn = setCouponBtn(item)
    return {
      ...item,
      cardBtn: [btn]
    }
  })
}
